module.exports = __webpack_public_path__ + "img/warning.990885e1.svg";